export default "__VITE_ASSET__CUpSOUEV__"